import React from 'react';
import PropTypes from 'prop-types';
import { DropdownSelect } from '../common/formElements';
import { DropdownBox, DropdownText, Dropdown } from './DropDown.styles';

const DropDown = ({
  title,
  selected,
  list,
  onSelectFunction,
  insideLabel,
  error,
  maxWidth,
  onClick,
  className,
  disabled,
}) => {
  const handleChange = (e) => {
    onSelectFunction(e.target.value);
  };

  return (
    <DropdownBox className={(error ? 'error' : '') + className} insideLabel={insideLabel}>
      {insideLabel
        ? null
        : title && (
            <DropdownText>
              {title}
              &#x3a;
            </DropdownText>
          )}
      <Dropdown>
        <DropdownSelect
          maxWidth={maxWidth || '200px'}
          className={insideLabel ? 'form-control' : ''}
          onChange={handleChange}
          value={selected && selected.id}
          onClick={onClick ? onClick : () => {}}
          disabled={disabled}
        >
          {insideLabel ? <option>{title}</option> : null}
          {list.map((item) => (
            <option key={item.id} value={item.id}>
              {item.label || item.value}
            </option>
          ))}
        </DropdownSelect>
      </Dropdown>
    </DropdownBox>
  );
};

export default DropDown;

const Field = PropTypes.shape({
  id: PropTypes.any,
  label: PropTypes.string,
  value: PropTypes.any,
});

DropDown.propTypes = {
  title: PropTypes.string,
  selected: PropTypes.oneOfType([Field, PropTypes.string]),
  list: PropTypes.arrayOf(Field),
  onSelectFunction: PropTypes.func.isRequired,
  insideLabel: PropTypes.bool,
  onClick: PropTypes.func,
};
